export var commonLocale = {
  yearFormat: 'YYYY',
  dayFormat: 'D',
  cellMeridiemFormat: 'A',
  monthBeforeYear: true
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-picker/es/locale/common.js
// module id = 1459
// module chunks = 0